import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  HiUsers,
  HiOfficeBuilding,
  HiCube,
  HiArchive,
  HiDocumentText,
  HiCalculator,
  HiCash,
  HiClipboardList,
  HiReceiptTax,
  HiPrinter,
  HiLocationMarker,
  HiCog,
  HiUser,
  HiHome,
  HiShoppingBag,
  HiSwitchHorizontal,
  HiStar,
  HiTrash,
  HiColorSwatch,
} from 'react-icons/hi';
import { usePermissions } from '../hooks/usePermissions';
import { useAuth } from '../contexts/AuthContext';
import { ROUTE_TO_PAGE_MAP } from '../constants/pageRoutes';
import { config } from '../config/environment';
import './Sidebar.css';

const Sidebar = ({ isOpen, collapsed = false, onToggleCollapse, onClose }) => {
  const location = useLocation();
  const { isAuthenticated } = useAuth();
  const { hasAccessToPage } = usePermissions();

  const routeToPageMap = ROUTE_TO_PAGE_MAP;

  const menuItems = [
    { path: '/dashboard', label: 'Dashboard', icon: HiHome },
    { path: '/rastreamento', label: 'Retirada', icon: HiShoppingBag },
    { path: '/clients', label: 'Clientes', icon: HiUsers },
    { path: '/solicitacoes-exclusao', label: 'Exclusão de contas', icon: HiTrash },
    { path: '/catalogo', label: 'Catálogo', icon: HiColorSwatch },
    { path: '/rewards', label: 'Rewards', icon: HiStar },
    { path: '/suppliers', label: 'Fornecedores', icon: HiOfficeBuilding },
    { path: '/boxes', label: 'Caixas / Malas', icon: HiCube },
    { path: '/organizar-caixa', label: 'Organizar Caixa', icon: HiArchive },
    { path: '/invoices', label: 'Invoices', icon: HiDocumentText },
    { path: '/labels', label: 'Etiquetas', icon: HiPrinter },
    { path: '/coletas', label: 'Coletas', icon: HiShoppingBag },
    { path: '/tracking', label: 'Rastreamento', icon: HiLocationMarker },
    { path: '/payments', label: 'Cobranças PIX', icon: HiCash },
    { path: '/pagamentos-retirada', label: 'Pagamentos', icon: HiClipboardList },
    { path: '/currency', label: 'Conversor', icon: HiSwitchHorizontal },
    { path: '/costs', label: 'Gestão de Custos', icon: HiCalculator },
    { path: '/central-fiscal', label: 'Central Fiscal', icon: HiReceiptTax },
    { path: '/users', label: 'Usuários', icon: HiUser },
    { path: '/settings', label: 'Configurações', icon: HiCog },
  ];

  // Filtrar itens de menu baseado nas permissões do usuário
  const filteredMenuItems = menuItems.filter(item => {
    // Se não estiver autenticado, não mostrar nenhum item (exceto se for público)
    if (!isAuthenticated) {
      return false;
    }
    const pageName = routeToPageMap[item.path];
    // Se a página não está mapeada, permitir (pode ser uma página especial)
    if (!pageName) {
      return true;
    }
    // Perfil sempre deve ser acessível
    if (pageName === 'profile') {
      return true;
    }
    // Verificar se o usuário tem acesso à página
    return hasAccessToPage(pageName);
  });

  const handleToggleCollapse = () => {
    if (onToggleCollapse) {
      onToggleCollapse();
    }
  };

  return (
    <>
      <aside className={`sidebar ${collapsed ? 'collapsed' : ''} ${isOpen ? 'open' : ''}`}>
        <div className="sidebar-header">
          <div className="logo-container">
            <img src="/logo.png" alt="SendingTo Express" className="logo-image" />
            {!collapsed && <span className="logo-text">SendingTo Express</span>}
          </div>
          {onToggleCollapse && (
            <button className="collapse-toggle" onClick={handleToggleCollapse}>
              <svg width='20' height='20' viewBox='0 0 24 24' fill='none'>
                <path
                  d='M15 18L9 12L15 6'
                  stroke='currentColor'
                  strokeWidth='2'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
              </svg>
            </button>
          )}
        </div>

        <nav className="sidebar-nav">
          {filteredMenuItems.map((item) => {
            const isActive = location.pathname === item.path;
            const IconComponent = item.icon;
            return (
              <Link
                key={item.path}
                to={item.path}
                className={`menu-item ${isActive ? 'active' : ''}`}
                onClick={onClose}
              >
                <span className="menu-icon">
                  <IconComponent size={20} />
                </span>
                <span className="menu-label">{item.label}</span>
              </Link>
            );
          })}
        </nav>

        <div className="sidebar-version">
          <span>V{config.APP_VERSION}</span>
        </div>
      </aside>
    </>
  );
};

export default Sidebar;